import { useState } from 'react'

import { useAppSelector } from '../../../shared/hooks'
import { ExportModal } from './components'

const ExportContacts = () => {
	const { appExportConnector } = useAppSelector(state => state.app)
	const [open, setOpen] = useState(false)

	const onOpen = () => {
		setOpen(true)
	}

	const onClose = () => {
		appExportConnector?.profilesExport?.clear()
		setOpen(false)
	}

	return (
		<>
			<button className='btn-text-icon add-icon' onClick={onOpen}>
				Add contacts
			</button>
			{open && <ExportModal onClose={onClose} open={open} />}
		</>
	)
}

export default ExportContacts
